import makeStyles from '@material-ui/styles/makeStyles'

export default makeStyles((theme) => ({
    secondary: {
        color: theme.palette.gray.main,
        textDecoration: 'none'
    }
}))
